import axios from 'axios';
const Fingerprint2 = require('fingerprintjs2');

class Poll {
  constructor(options) {
    var defaults = {
      containerSelector: '.poll',
      responseSelector: '.response',
      tokenEndpoint: '/index.php?option=com_news&task=getip&format=json',
      voteEndpoint: '/index.php?option=com_news&task=submitPoll&format=json',
      messages: {
        retry: 'Παρακαλώ δοκιμάστε ξανά αργότερα'
      },
      id: 0
    };
    this.params = Object.assign({}, defaults, options || {});
    this.container = document.querySelector(this.params.containerSelector);
    this.response = this.container.querySelector(this.params.responseSelector);
    this.radios = this.container.querySelectorAll('input[type=radio]');

    this.state = [];
    this.start();
  }

  start() {

    const state = this.getState();

    if (state) {
      this.state = state;
      this.update();
    }

    Fingerprint2().get((result) => {
      this.fingerprint = result;
      this.addEvents();
    });

  }

  addEvents() {
    for (let index = 0; index < this.radios.length; index++) {
      this.radios[index].addEventListener('change', (event) => {
        this.onChoice(event);
      });
    }
  }

  onChoice(event) {

    const exists = this.state.find(entry => entry.question === parseInt(event.target.dataset.choices));

    if(exists) {
      return;
    }

    let data = new FormData();
    data.append('id', event.target.dataset.id);
    data.append('choices', event.target.dataset.choices);
    data.append('choice', event.target.dataset.choice);
    data.append('un', this.fingerprint);

    this.getToken().then((response) => {

      if (!response.data.success) {
        this.response.textContent = response.data.message;
        return;
      }

      if (!response.data.data.token) {
        this.response.textContent = this.params.messages.retry;
        return;
      }

      data.append(response.data.data.token, '1');

      this.vote(data);

    }).catch((error) => {
      this.response.textContent = this.params.messages.retry;
    });

  }

  getState() {
    const json = localStorage.getItem('poll_' + this.params.id);
    if (!json) {
      return [];
    }
    const state = JSON.parse(json);
    if(!Array.isArray(state)) {
      return [];
    }
    return state;
  }

  setState() {
    localStorage.setItem('poll_' + this.params.id, JSON.stringify(this.state));
  }

  update() {
    for (let i = 0; i < this.state.length; i++) {
      let entry = this.state[i];
      if(entry.voted) {
        this.container.querySelector('.poll-choices-' + entry.question).classList.add('already-voted');
        let selected = this.container.querySelector('#poll-' + this.params.id + '-option-' + entry.voted);
        if(selected) {
          selected.classList.add('choosed');
        }
      }
    }
  }

  vote(data) {
    axios.post(this.params.voteEndpoint, data, {
      headers: {
        'content-type': 'application/x-www-form-urlencoded'
      }
    }).then((response) => {
      if (response.data.success) {
        this.state.push({
          question: response.data.data.question,
          voted: response.data.data.vote
        });
        this.setState();
        this.update();
      }
      this.response.textContent = response.data.data.message;
    }).catch((error) => {
      this.response.textContent = this.params.messages.retry;
    });
  }

  getToken() {
    return axios.post(this.params.tokenEndpoint + '&unique=' + this.fingerprint);
  }

}

export {
  Poll as
  default
};
